var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgItalianFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1500,
  height: 1000,
  viewBox: "0 0 3 2"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 2,
  fill: "#009246"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 1,
  fill: "#fff"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 2,
  x: 2,
  fill: "#ce2b37"
})));
export { SvgItalianFlag as ReactComponent };
export default __webpack_public_path__ + "3094e87722c26e87e1ffa034fb4bfa11.svg";